/**
 * Make/Model/Year Finder - Interactive UI for vehicle search
 * Uses custom dropdowns matching Car Kits Finder style
 */

// Wrap in IIFE to prevent duplicate declaration errors if script loads twice
(function() {
  'use strict';
  
  // Prevent double initialization
  if (window.__MMYFinderInitialized) {
    console.log('🚗 Make/Model/Year Finder: Already initialized, skipping...');
    return;
  }
  window.__MMYFinderInitialized = true;

  console.log('🚗 Make/Model/Year Finder: Script loaded successfully!');

  const LUNA_API_BASE = 'https://luna-paint-api-298547824318.us-central1.run.app';

  // Session cache for API responses
  const API_CACHE = {
    brands: null,
    models: {}, // Key by brand name
    years: {},  // Key by modelId
  };

  // Brand logo mapping - maps make names to asset filenames
  // Logos are in assets/ folder with naming: brand-logo-{name}.png
  const BRAND_LOGOS = {
    'alfa romeo': 'brand-logo-alfa-romeo.png',
    'alfa': 'brand-logo-alfa-romeo.png',
    'american motors': 'brand-logo-american-motors.png',
    'amc': 'brand-logo-american-motors.png',
    'aston martin': 'brand-logo-aston-martin.png',
    'aston': 'brand-logo-aston-martin.png',
    'audi': 'brand-logo-audi.png',
    'bentley': 'brand-logo-bentley.png',
    'bmw m': 'brand-logo-bmw-m.png',
    'bmw': 'brand-logo-bmw.png',
    'bugatti': 'brand-logo-bugatti.png',
    'buick': 'brand-logo-buick.png',
    'cadillac': 'brand-logo-cadillac.png',
    'caddy': 'brand-logo-cadillac.png',
    'chevrolet': 'brand-logo-chevrolet.png',
    'chevy': 'brand-logo-chevrolet.png',
    'chrysler': 'brand-logo-chrysler.png',
    'dodge': 'brand-logo-dodge.png',
    'ferrari': 'brand-logo-ferrari.png',
    'fiat': 'brand-logo-fiat.png',
    'fisker': 'brand-logo-fisker.png',
    'ford': 'brand-logo-ford.png',
    'franklin': 'brand-logo-franklin.png',
    'freightliner': 'brand-logo-freightliner.png',
    'general motors': 'brand-logo-general-motors.png',
    'gm': 'brand-logo-general-motors.png',
    'genesis': 'brand-logo-genesis.png',
    'gmc': 'brand-logo-gmc.png',
    'honda': 'brand-logo-honda.png',
    'acura': 'brand-logo-honda.png', // Honda's luxury brand
    'hummer': 'brand-logo-hummer.png',
    'hyundai': 'brand-logo-hyundai.png',
    'infiniti': 'brand-logo-infiniti.png',
    'jaguar': 'brand-logo-jaguar.png',
    'jag': 'brand-logo-jaguar.png',
    'jeep': 'brand-logo-jeep.png',
    'karma': 'brand-logo-karma.png',
    'kenworth': 'brand-logo-kenworth.png',
    'kia': 'brand-logo-kia.png',
    'ktm': 'brand-logo-ktm.png',
    'lamborghini': 'brand-logo-lamborghini.png',
    'lambo': 'brand-logo-lamborghini.png',
    'lexus': 'brand-logo-lexus.png',
    'lotus': 'brand-logo-lotus.png',
    'lucid': 'brand-logo-lucid.png',
    'maserati': 'brand-logo-maserati.png',
    'mazda': 'brand-logo-mazda.png',
    'mercedes-benz': 'brand-logo-mercedes-benz.png',
    'mercedes benz': 'brand-logo-mercedes-benz.png',
    'mercedes': 'brand-logo-mercedes-benz.png',
    'merc': 'brand-logo-mercedes-benz.png',
    'mb': 'brand-logo-mercedes-benz.png',
    'mercury': 'brand-logo-mercury.png',
    'mini': 'brand-logo-mini.png',
    'mini cooper': 'brand-logo-mini.png',
    'mitsubishi': 'brand-logo-mitsubishi.png',
    'nissan': 'brand-logo-nissan.png',
    'datsun': 'brand-logo-nissan.png',
    'oldsmobile': 'brand-logo-oldsmobile.png',
    'olds': 'brand-logo-oldsmobile.png',
    'peterbilt': 'brand-logo-peterbilt.png',
    'plymouth': 'brand-logo-plymouth.png',
    'pontiac': 'brand-logo-pontiac.png',
    'porsche': 'brand-logo-porsche.png',
    'ram': 'brand-logo-ram.png',
    'rivian': 'brand-logo-rivian.png',
    'rolls-royce': 'brand-logo-rolls-royce.png',
    'rolls royce': 'brand-logo-rolls-royce.png',
    'rolls': 'brand-logo-rolls-royce.png',
    'subaru': 'brand-logo-subaru.png',
    'subi': 'brand-logo-subaru.png',
    'suzuki': 'brand-logo-suzuki.png',
    'tesla': 'brand-logo-tesla.png',
    'toyota': 'brand-logo-toyota.png',
    'scion': 'brand-logo-toyota.png', // Toyota's youth brand
    'trion': 'brand-logo-trion.png',
    'volkswagen': 'brand-logo-volkswagen.png',
    'vw': 'brand-logo-volkswagen.png',
    'volvo': 'brand-logo-volvo.png',
    'polestar': 'brand-logo-volvo.png', // Volvo's performance brand
    'land rover': 'brand-logo-jaguar.png', // JLR group
    'lincoln': 'brand-logo-ford.png', // Ford's luxury brand
  };

  // Store asset URL base (set from Liquid template)
  let ASSET_URL_BASE = null;

  /**
   * Get brand logo URL for a given make name
   * Uses Shopify's asset_url pattern from the template
   * @param {string} make - The vehicle make name
   * @returns {string|null} - The asset URL for the logo or null if not found
   */
  function getBrandLogoUrl(make) {
    if (!make || !ASSET_URL_BASE) return null;
    const normalizedMake = make.toLowerCase().trim();
    const logoFile = BRAND_LOGOS[normalizedMake];
    if (logoFile) {
      return `${ASSET_URL_BASE}${logoFile}`;
    }
    return null;
  }

  // Initialize all finders on the page
  document.addEventListener('DOMContentLoaded', function() {
  console.log('🚗 Make/Model/Year Finder: Initializing...');
  const finders = document.querySelectorAll('.make-model-year-finder');
  console.log('🚗 Make/Model/Year Finder: Found', finders.length, 'finders');
  
  finders.forEach((finder, index) => {
    console.log('🚗 Make/Model/Year Finder: Initializing finder', index + 1);
    initFinder(finder);
  });
});

/**
 * Initialize a single finder
 */
function initFinder(container) {
  console.log('🚗 Initializing finder on:', container);
  
  const endpoint = container.dataset.endpoint;
  const drawerId = container.dataset.drawerId;
  
  // Set asset URL base for brand logos (from Liquid template)
  if (container.dataset.assetUrlBase && !ASSET_URL_BASE) {
    ASSET_URL_BASE = container.dataset.assetUrlBase;
    console.log('🚗 Brand logo asset URL base:', ASSET_URL_BASE);
  }
  
  // Get dropdown elements
  const makeDropdown = container.querySelector('.make-dropdown');
  const modelDropdown = container.querySelector('.model-dropdown');
  const yearDropdown = container.querySelector('.year-dropdown');
  const searchBtn = container.querySelector('.finder-search-btn');
  
  // State management
  const state = {
    make: null,
    model: null,
    modelId: null,
    year: null,
    endpoint: endpoint,
    drawerId: drawerId,
    container: container,
    hasModels: true  // Track if models are available for selected make
  };
  
  // Setup custom dropdowns
  setupCustomDropdown(makeDropdown, state, 'make');
  setupCustomDropdown(modelDropdown, state, 'model');
  setupCustomDropdown(yearDropdown, state, 'year');
  
  // Setup keyboard navigation
  setupKeyboardNavigation(makeDropdown, state, 'make');
  setupKeyboardNavigation(modelDropdown, state, 'model');
  setupKeyboardNavigation(yearDropdown, state, 'year');
  
  // Setup search button
  searchBtn.addEventListener('click', () => onSearch(state, endpoint, drawerId));
  
  // Load initial data (brands)
  loadBrands(state, makeDropdown, modelDropdown, yearDropdown, searchBtn);
  
  // Render recent searches
  renderRecentSearches(state);
  
  // Setup text search mode toggle
  setupTextSearchToggle(state, container);
  
  // Setup license plate search toggle
  setupPlateSearchToggle(state, container);
  
  console.log('🚗 Finder initialized successfully');
}

/**
 * Setup a custom dropdown with click handlers
 */
function setupCustomDropdown(dropdown, state, type) {
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const options = dropdown.querySelector('.kits-finder__dropdown-options');
  
  // Move dropdown options to body on first click to escape overflow clipping
  let optionsMovedToBody = false;
  
  // Toggle dropdown
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check if disabled or loading
    if (trigger.getAttribute('data-disabled') === 'true' || trigger.getAttribute('data-loading') === 'true') {
      if (trigger.getAttribute('data-disabled') === 'true') {
        showTooltip(trigger, 'Select previous option first');
      }
      return;
    }
    
    const isOpen = dropdown.classList.contains('open');
    
    // Close all other dropdowns (but don't unlock body yet - we'll handle that below)
    document.querySelectorAll('.kits-finder__dropdown.open').forEach(otherDropdown => {
      if (otherDropdown !== dropdown) {
        otherDropdown.classList.remove('open');
        // Also close their options if moved to body
        const otherOptions = otherDropdown.querySelector('.kits-finder__dropdown-options');
        if (otherOptions && otherOptions.parentElement === document.body) {
          otherOptions.classList.remove('open');
        }
      }
    });
    
    // Toggle current dropdown
    dropdown.classList.toggle('open', !isOpen);
    
    // Move options to body and position it if opening
    if (!isOpen) {
      if (!optionsMovedToBody) {
        document.body.appendChild(options);
        // Mark this as a make-model-year dropdown for styling
        options.setAttribute('data-finder-type', 'make-model-year');
        // Store reference to parent dropdown for later lookup
        options._parentDropdown = dropdown;
        optionsMovedToBody = true;
        console.log('🚗 Moved dropdown options to body');
      }
      
      // Lock body scroll on BOTH mobile AND desktop BEFORE positioning (prevents jump and scroll)
      // Android-safe: use overflow:hidden only, no position:fixed + top manipulation
      if (!document.body.hasAttribute('scroll-locked')) {
        const scrollY = window.scrollY;
        document.body.dataset.scrollY = scrollY;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.setAttribute('scroll-locked', 'true');
      }

      // Position the options relative to the trigger
      // Use requestAnimationFrame to ensure layout is complete (iOS Safari fix)
      requestAnimationFrame(() => {
        const rect = trigger.getBoundingClientRect();
        options.style.position = 'fixed';
        // Position exactly at bottom edge (trigger bottom border is transparent when open)
        options.style.top = rect.bottom + 'px';
        options.style.left = rect.left + 'px';
        // Set width with !important priority via cssText to ensure it matches trigger exactly
        options.style.setProperty('width', rect.width + 'px', 'important');
        console.log('🚗 Positioned dropdown:', { top: rect.bottom, left: rect.left, width: rect.width });
      });

      // Add open class to options since it's no longer a child of dropdown
      options.classList.add('open');
    } else {
      // Remove open class when closing
      options.classList.remove('open');

      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
        const scrollY = document.body.dataset.scrollY;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('scroll-locked');
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target) && !options.contains(e.target)) {
      const wasOpen = dropdown.classList.contains('open');
      dropdown.classList.remove('open');
      options.classList.remove('open');

      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only
      if (wasOpen) {
        const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
        if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
          const scrollY = document.body.dataset.scrollY;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
          document.body.removeAttribute('scroll-locked');
          if (scrollY) {
            window.scrollTo(0, parseInt(scrollY));
            delete document.body.dataset.scrollY;
          }
        }
      }
    }
  });
  
  // Reposition dropdown on resize and orientation change only (body is locked, no scroll)
  let repositionFrame = null;
  
  function repositionDropdown() {
    // Only reposition on actual device rotation, not keyboard appearance
    if (dropdown.classList.contains('open') && options.parentElement === document.body) {
      // Cancel any pending frame to avoid stacking
      if (repositionFrame) {
        cancelAnimationFrame(repositionFrame);
      }
      
      repositionFrame = requestAnimationFrame(() => {
        const rect = trigger.getBoundingClientRect();
        
        // Position exactly at bottom edge (trigger bottom border is transparent when open)
        options.style.top = rect.bottom + 'px';
        options.style.left = rect.left + 'px';
        // Set width with !important priority to ensure it matches trigger exactly
        options.style.setProperty('width', rect.width + 'px', 'important');
        
        repositionFrame = null;
      });
    }
  }
  
  // Only reposition on orientation change (not resize which triggers on keyboard)
  window.addEventListener('orientationchange', repositionDropdown, { passive: true });
}

// Global ESC key listener to close ALL make-model-year dropdowns
// This runs once globally, not per-instance
let globalEscListener = null;
if (!globalEscListener) {
  globalEscListener = function(e) {
    if (e.key === 'Escape') {
      const openDropdowns = document.querySelectorAll('.make-model-year-finder .kits-finder__dropdown.open');
      if (openDropdowns.length > 0) {
        e.preventDefault();
        openDropdowns.forEach(dropdown => {
          dropdown.classList.remove('open');
          // Find and close associated options (might be in body)
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          allBodyOptions.forEach(opt => {
            if (opt._parentDropdown === dropdown) {
              opt.classList.remove('open');
            }
          });
        });
        
        // Unlock body scroll when closing
        // Android-safe: use overflow only
        const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
        if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
          const scrollY = document.body.dataset.scrollY;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
          document.body.removeAttribute('scroll-locked');
          if (scrollY) {
            window.scrollTo(0, parseInt(scrollY));
            delete document.body.dataset.scrollY;
          }
        }
      }
    }
  };
  document.addEventListener('keydown', globalEscListener);
}

/**
 * Setup keyboard navigation for dropdown
 */
function setupKeyboardNavigation(dropdown, state, type) {
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const options = dropdown.querySelector('.kits-finder__dropdown-options');
  
  let selectedIndex = -1;
  
  // Enter or Space on trigger opens dropdown
  trigger.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (trigger.getAttribute('data-disabled') !== 'true' && trigger.getAttribute('data-loading') !== 'true') {
        trigger.click();
      }
    }
  });
  
  // Arrow keys, Enter, Escape navigation in options
  document.addEventListener('keydown', function(e) {
    if (!dropdown.classList.contains('open')) {
      selectedIndex = -1;
      return;
    }
    
    const allOptions = Array.from(options.querySelectorAll('.kits-finder__dropdown-option:not([style*="display: none"])'));
    
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      selectedIndex = Math.min(selectedIndex + 1, allOptions.length - 1);
      highlightOption(allOptions, selectedIndex);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      selectedIndex = Math.max(selectedIndex - 1, 0);
      highlightOption(allOptions, selectedIndex);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (selectedIndex >= 0 && allOptions[selectedIndex]) {
        allOptions[selectedIndex].click();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      dropdown.classList.remove('open');
      options.classList.remove('open');
      selectedIndex = -1;

      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
        const scrollY = document.body.dataset.scrollY;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('scroll-locked');
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }
    }
  });
}

/**
 * Highlight option during keyboard navigation
 */
function highlightOption(options, index) {
  options.forEach((opt, i) => {
    opt.classList.toggle('keyboard-highlighted', i === index);
  });
  if (options[index]) {
    options[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
}

/**
 * Show tooltip for disabled dropdown
 */
function showTooltip(trigger, message) {
  let tooltip = document.querySelector('.kits-finder__disabled-tooltip');
  
  if (!tooltip) {
    tooltip = document.createElement('div');
    tooltip.className = 'kits-finder__disabled-tooltip';
    document.body.appendChild(tooltip);
  }
  
  tooltip.textContent = message;
  
  const rect = trigger.getBoundingClientRect();
  tooltip.style.left = rect.left + (rect.width / 2) + 'px';
  tooltip.style.top = rect.top - 8 + 'px';
  
  tooltip.offsetHeight; // Force reflow
  tooltip.classList.add('show');
  
  setTimeout(() => {
    tooltip.classList.remove('show');
  }, 2000);
}

/**
 * Populate dropdown options
 */
function populateDropdownOptions(dropdown, items, state, type) {
  console.log('🚗 populateDropdownOptions called:', { type, itemCount: items.length });
  
  // First try to find options in dropdown, then check if it's been moved to body
  let optionsContainer = dropdown.querySelector('.kits-finder__dropdown-options');
  
  // If not found in dropdown, it might have been moved to body - search by stored reference
  if (!optionsContainer) {
    const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
    
    // Find which one belongs to this dropdown by checking stored parent reference
    for (const option of allBodyOptions) {
      if (option._parentDropdown === dropdown) {
        optionsContainer = option;
        console.log('🚗 Found options container in body for this dropdown');
        break;
      }
    }
  }
  
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const triggerText = trigger ? trigger.querySelector('.kits-finder__dropdown-text') : null;
  
  console.log('🚗 Dropdown elements:', {
    hasOptionsContainer: !!optionsContainer,
    hasTrigger: !!trigger,
    hasTriggerText: !!triggerText
  });
  
  if (!optionsContainer || !trigger || !triggerText) {
    console.error('🚗 Missing dropdown elements!');
    return;
  }
  
  // Clear existing options
  optionsContainer.innerHTML = '';
  
  // Add search input at top of dropdown
  const searchInput = document.createElement('input');
  searchInput.type = 'text';
  searchInput.className = 'kits-finder__dropdown-search';
  searchInput.placeholder = `Search ${type}...`;
  searchInput.addEventListener('click', e => e.stopPropagation());
  searchInput.addEventListener('input', e => {
    filterDropdownOptions(e.target.value, optionsContainer);
    
    // Track dropdown search usage
    if (e.target.value.length >= 2 && window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'dropdown_search_used',
        label: type,
        metadata: { query: e.target.value }
      });
    }
  });
  optionsContainer.appendChild(searchInput);
  
  // Setup scroll detection for search input visibility
  setupDropdownScrollBehavior(optionsContainer, searchInput);
  
  // Add options
  items.forEach((item, index) => {
    console.log(`🚗 Creating option ${index + 1}:`, item.label);
    const option = document.createElement('div');
    option.className = 'kits-finder__dropdown-option';
    option.dataset.value = item.value;
    if (item.id) option.dataset.id = item.id;
    
    const text = document.createElement('span');
    text.className = 'dropdown-option-text';
    text.textContent = item.label;
    option.appendChild(text);
    
    // Click handler
    option.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('🚗 Option clicked:', { type, label: item.label, value: item.value, id: item.id });
      
      // Update trigger text
      triggerText.textContent = item.label;
      
      // Update selected state
      optionsContainer.querySelectorAll('.kits-finder__dropdown-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
      
      // Close dropdown
      dropdown.classList.remove('open');
      optionsContainer.classList.remove('open');
      
      // Unlock body scroll when closing (only if no other dropdowns are open)
      // Android-safe: use overflow only
      const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
      if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
        const scrollY = document.body.dataset.scrollY;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('scroll-locked');
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }

      // Update state and trigger cascade
      if (type === 'make') {
        state.make = item.value;
        state.model = null;
        state.modelId = null;
        state.year = null;
        state.hasModels = true;  // Reset to true, will be set to false if no models found
        console.log('🚗 Make selected:', state.make, '(from item.value:', item.value, ')');
        
        // Reset search button text
        const searchBtn = state.container.querySelector('.finder-search-btn');
        const btnText = searchBtn.querySelector('.finder-btn-text');
        btnText.textContent = 'Search';
        searchBtn.disabled = true;
        searchBtn.style.opacity = '0.5';
        searchBtn.style.pointerEvents = 'none';
        
        // Reset model and year dropdown texts and clear options
        const modelDropdown = state.container.querySelector('.model-dropdown');
        const yearDropdown = state.container.querySelector('.year-dropdown');
        const modelTrigger = modelDropdown.querySelector('.kits-finder__dropdown-trigger');
        const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
        modelTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Model...';
        yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
        
        // Clear model dropdown options (whether in dropdown or body)
        let modelOptionsContainer = modelDropdown.querySelector('.kits-finder__dropdown-options');
        if (!modelOptionsContainer) {
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          for (const option of allBodyOptions) {
            if (option._parentDropdown === modelDropdown) {
              modelOptionsContainer = option;
              break;
            }
          }
        }
        if (modelOptionsContainer) {
          modelOptionsContainer.innerHTML = '';
        }
        
        // Clear year dropdown options (whether in dropdown or body)
        let yearOptionsContainer = yearDropdown.querySelector('.kits-finder__dropdown-options');
        if (!yearOptionsContainer) {
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          for (const option of allBodyOptions) {
            if (option._parentDropdown === yearDropdown) {
              yearOptionsContainer = option;
              break;
            }
          }
        }
        if (yearOptionsContainer) {
          yearOptionsContainer.innerHTML = '';
        }
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'make_selected',
            label: item.value
          });
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'funnel_step',
            label: 'make|' + item.value
          });
        }

        // Load models for this make
        const finderContainer = state.container.querySelector('.finder-container');
        finderContainer.classList.remove('make-only-mode');
        loadModels(state, item.value, modelDropdown, yearDropdown, searchBtn);
        
      } else if (type === 'model') {
        state.model = item.value;
        state.modelId = item.id;
        state.year = null;
        console.log('🚗 Model selected:', item.value, 'ID:', item.id);
        
        // Reset search button text
        const searchBtn = state.container.querySelector('.finder-search-btn');
        const btnText = searchBtn.querySelector('.finder-btn-text');
        btnText.textContent = 'Search';
        searchBtn.disabled = true;
        searchBtn.style.opacity = '0.5';
        searchBtn.style.pointerEvents = 'none';
        
        // Reset year dropdown text and clear options
        const yearDropdown = state.container.querySelector('.year-dropdown');
        const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
        yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
        yearTrigger.setAttribute('data-disabled', 'true');
        
        // Clear year dropdown options (whether in dropdown or body)
        let yearOptionsContainer = yearDropdown.querySelector('.kits-finder__dropdown-options');
        if (!yearOptionsContainer) {
          const allBodyOptions = document.querySelectorAll('body > .kits-finder__dropdown-options[data-finder-type="make-model-year"]');
          for (const option of allBodyOptions) {
            if (option._parentDropdown === yearDropdown) {
              yearOptionsContainer = option;
              break;
            }
          }
        }
        if (yearOptionsContainer) {
          yearOptionsContainer.innerHTML = '';
        }
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'model_selected',
            label: `${state.make} - ${item.value}`
          });
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'funnel_step',
            label: 'model|' + item.value
          });
        }

        // Load years for this model
        loadYears(state, item.id, yearDropdown, searchBtn);
        
      } else if (type === 'year') {
        state.year = item.value;
        console.log('🚗 Year selected:', item.value);
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'year_selected',
            label: `${state.make} ${state.model} ${item.value}`
          });
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'funnel_step',
            label: 'year|' + item.value
          });
        }

        // Enable search button
        const searchBtn = state.container.querySelector('.finder-search-btn');
        updateSearchButton(state, searchBtn);
      }
    });
    
    optionsContainer.appendChild(option);
  });
  
  // Remove loading state
  trigger.removeAttribute('data-loading');
  
  console.log('🚗 Populated', items.length, type, 'options');
  console.log('🚗 Options container children count:', optionsContainer.children.length);
  console.log('🚗 First option HTML:', optionsContainer.children[0]?.outerHTML);
}

/**
 * Filter dropdown options based on search query
 */
function filterDropdownOptions(query, container) {
  const options = container.querySelectorAll('.kits-finder__dropdown-option');
  const lowerQuery = query.toLowerCase();
  
  options.forEach(opt => {
    const text = opt.textContent.toLowerCase();
    opt.style.display = text.includes(lowerQuery) ? 'flex' : 'none';
  });
}

/**
 * Setup scroll behavior for dropdown search input
 */
function setupDropdownScrollBehavior(optionsContainer, searchInput) {
  let lastScrollTop = 0;
  
  optionsContainer.addEventListener('scroll', function() {
    const scrollTop = optionsContainer.scrollTop;
    
    if (scrollTop > lastScrollTop && scrollTop > 50) {
      // Scrolling DOWN - hide search input
      searchInput.classList.add('hidden-on-scroll');
    } else if (scrollTop < lastScrollTop) {
      // Scrolling UP - show search input
      searchInput.classList.remove('hidden-on-scroll');
    }
    
    // If at the very top, always show
    if (scrollTop <= 10) {
      searchInput.classList.remove('hidden-on-scroll');
    }
    
    lastScrollTop = scrollTop;
  });
}

/**
 * Setup text search mode toggle
 */
function setupTextSearchToggle(state, container) {
  const toggleBtn = container.querySelector('.finder-mode-toggle');
  const toggleBackBtn = container.querySelector('.finder-mode-toggle-back');
  const finderContainer = container.querySelector('.finder-container');
  const textSearchContainer = container.querySelector('.finder-text-search-container');
  const textSearchInput = container.querySelector('.finder-text-search-input');
  const textSearchBtn = container.querySelector('.finder-text-search-btn');
  const bottomRow = container.querySelector('.finder-bottom-row');
  
  // Find the subtext elements (both desktop and mobile)
  const slide = container.closest('.slider-slide');
  const subtextElements = slide ? slide.querySelectorAll('.finder-subtext') : [];
  
  // Set initial state: hide subtext if no dropdown text
  subtextElements.forEach(el => {
    const dropdownText = el.getAttribute('data-dropdown-text');
    if (!dropdownText) {
      el.style.display = 'none';
    }
  });
  
  if (!toggleBtn || !textSearchContainer) return;
  
  // Toggle to text search mode
  toggleBtn.addEventListener('click', () => {
    // Update subtext to text search mode
    subtextElements.forEach(el => {
      const textSearchText = el.getAttribute('data-text-search-text');
      if (textSearchText) {
        el.innerHTML = textSearchText;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
    
    // Animate transition
    finderContainer.classList.add('hidden-mode');
    if (bottomRow) {
      bottomRow.style.opacity = '0';
      bottomRow.style.transition = 'opacity 0.2s ease';
    }
    
    // Show text search after dropdown animation
    setTimeout(() => {
      if (bottomRow) {
        bottomRow.style.display = 'none';
      }
      textSearchContainer.style.display = 'flex';
      textSearchContainer.style.flexDirection = 'column';
      textSearchContainer.style.alignItems = 'center';
      requestAnimationFrame(() => {
        textSearchContainer.classList.add('active');
      });
    }, 150);
    
    // Track mode switch
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'mode_switched',
        label: 'text_search'
      });
    }
  });
  
  // Toggle back to dropdown mode
  toggleBackBtn.addEventListener('click', () => {
    // Update subtext back to dropdown mode
    subtextElements.forEach(el => {
      const dropdownText = el.getAttribute('data-dropdown-text');
      if (dropdownText) {
        el.innerHTML = dropdownText;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
    
    textSearchContainer.classList.remove('active');
    
    setTimeout(() => {
      textSearchContainer.style.display = 'none';
      finderContainer.classList.remove('hidden-mode');
      if (bottomRow) {
        bottomRow.style.display = 'flex';
        bottomRow.style.opacity = '0';
        requestAnimationFrame(() => {
          bottomRow.style.transition = 'opacity 0.3s ease';
          bottomRow.style.opacity = '1';
        });
      }
    }, 150);
    
    // Track mode switch
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'mode_switched',
        label: 'dropdown'
      });
    }
  });
  
  // Handle text search
  const performTextSearch = () => {
    const query = textSearchInput.value.trim();
    if (!query) return;
    
    // Track text search
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'text_search_executed',
        label: query
      });
    }
    
    // Open MCC iframe with text query (same as mcc-search-input)
    openMCCWithTextQuery(query);
  };
  
  textSearchBtn.addEventListener('click', performTextSearch);
  textSearchInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performTextSearch();
    }
  });
}

/**
 * Open MCC app with text query (for text search mode)
 */
function openMCCWithTextQuery(query) {
  console.log('🚗 Opening MCC app with text query:', query);

  // Add class to body to hide Shopify chat via CSS
  document.body.classList.add('mcc-drawer-open');

  // Get or create the MCC iframe
  let iframe = document.getElementById('mcc-iframe');

  if (!iframe) {
    console.log('🚗 MCC iframe not found, creating one...');
    iframe = createMCCIframe();
  }

  // Show the iframe
  iframe.style.display = 'block';

  // Send message to MCC app with text query
  const message = {
    type: 'openModal',
    window: 'colorSearch',
    searchQuery: query
  };
  
  console.log('🚗 Sending text query to MCC app:', message);
  
  // Wait for iframe to be ready, then send message
  setTimeout(() => {
    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage(message, '*');
      console.log('🚗 Text query sent to MCC app');
    }
  }, 100);
}

/**
 * Load brands from Luna Paint API
 */
async function loadBrands(state, makeDropdown, modelDropdown, yearDropdown, searchBtn) {
  const trigger = makeDropdown.querySelector('.kits-finder__dropdown-trigger');
  
  // Check cache first
  if (API_CACHE.brands) {
    console.log('🚗 Using cached brands');
    populateDropdownOptions(makeDropdown, API_CACHE.brands, state, 'make');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Make...';
    return;
  }
  
  console.log('🚗 Fetching brands from Luna Paint API...');
  trigger.setAttribute('data-loading', 'true');
  trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Loading...';
  
  try {
    const _t0 = Date.now();
    const response = await fetch(`${LUNA_API_BASE}/brands`);
    const brands = await response.json();
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', { category: 'make_model_year_finder', source: 'carousel_widget', action: 'api_latency', label: 'brands|' + (Date.now() - _t0) + '|' + brands.length });
    }
    
    console.log('🚗 Brands loaded:', brands.length);
    console.log('🚗 First brand object:', brands[0]);
    
    const brandItems = brands.map(brand => {
      // Handle if brand is an object or a string
      const brandName = typeof brand === 'string' ? brand : (brand.brand || brand.name);
      
      return {
        value: brandName,
        label: brandName
      };
    });
    
    // Cache the results
    API_CACHE.brands = brandItems;
    
    populateDropdownOptions(makeDropdown, brandItems, state, 'make');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Make...';
    
    // Track analytics
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'brands_loaded',
        label: brands.length.toString()
      });
    }
    
  } catch (error) {
    console.error('🚗 Error loading brands:', error);
    trigger.removeAttribute('data-loading');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Error loading makes';
  }
}

/**
 * Load models for a brand
 */
async function loadModels(state, brandName, modelDropdown, yearDropdown, searchBtn) {
  const trigger = modelDropdown.querySelector('.kits-finder__dropdown-trigger');
  const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
  const finderContainer = state.container.querySelector('.finder-container');
  
  // Check cache first
  if (API_CACHE.models[brandName]) {
    console.log('🚗 Using cached models for', brandName);
    const cachedModels = API_CACHE.models[brandName];
    
    if (cachedModels.length === 0) {
      // Handle cached empty result
      state.hasModels = false;
      trigger.removeAttribute('data-loading');
      trigger.setAttribute('data-disabled', 'true');
      trigger.querySelector('.kits-finder__dropdown-text').textContent = 'No models available';
      yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'No years available';
      finderContainer.classList.add('make-only-mode');
      updateSearchButton(state, searchBtn);
      return;
    }
    
    state.hasModels = true;
    finderContainer.classList.remove('make-only-mode');
    trigger.removeAttribute('data-disabled');
    populateDropdownOptions(modelDropdown, cachedModels, state, 'model');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Model...';
    yearTrigger.setAttribute('data-disabled', 'true');
    yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
    return;
  }
  
  console.log('🚗 Fetching models for brand:', brandName);
  
  // Set loading state
  trigger.setAttribute('data-loading', 'true');
  trigger.removeAttribute('data-disabled');
  trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Loading...';
  
  // Reset year dropdown
  yearTrigger.setAttribute('data-disabled', 'true');
  yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
  yearDropdown.querySelector('.kits-finder__dropdown-options').innerHTML = '';
  
  // Disable search button
  searchBtn.disabled = true;
  
  try {
    const _t0 = Date.now();
    const response = await fetch(`${LUNA_API_BASE}/models/?brand=${encodeURIComponent(brandName)}`);
    const models = await response.json();
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', { category: 'make_model_year_finder', source: 'carousel_widget', action: 'api_latency', label: 'models|' + (Date.now() - _t0) + '|' + models.length });
    }
    
    console.log('🚗 Models loaded for', brandName, ':', models.length);
    console.log('🚗 First model object:', models[0]);
    
    // Check if no models available
    if (!models || models.length === 0) {
      console.log('🚗 No models available for', brandName, '- enabling search with just Make');
      state.hasModels = false;
      trigger.removeAttribute('data-loading');
      trigger.setAttribute('data-disabled', 'true');
      trigger.querySelector('.kits-finder__dropdown-text').textContent = 'No models available';
      
      // Also disable year dropdown
      yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = 'No years available';
      
      // Hide model and year dropdowns (make-only mode)
      finderContainer.classList.add('make-only-mode');
      
      // Cache empty result
      API_CACHE.models[brandName] = [];
      
      // Enable search button with just Make
      updateSearchButton(state, searchBtn);
      
      // Track analytics
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'make_model_year_finder', source: 'carousel_widget',
          action: 'models_loaded',
          label: brandName,
          metadata: { count: 0, hasModels: false }
        });
      }
      
      return;
    }
    
    state.hasModels = true;
    finderContainer.classList.remove('make-only-mode');
    
    const modelItems = models.map(model => {
      // Handle if model is an object or a string
      const modelName = typeof model === 'string' ? model : (model.type || model.model || model.name);
      const modelId = typeof model === 'object' ? model.id : null;
      
      console.log('🚗 Mapping model:', { original: model, modelName, modelId });
      
      return {
        value: modelName,
        label: modelName,
        id: modelId
      };
    });
    
    // Cache the results
    API_CACHE.models[brandName] = modelItems;
    
    populateDropdownOptions(modelDropdown, modelItems, state, 'model');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Model...';
    
    // Track analytics
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'models_loaded',
        label: brandName,
        metadata: { count: models.length, hasModels: true }
      });
    }
    
  } catch (error) {
    console.error('🚗 Error loading models:', error);
    trigger.removeAttribute('data-loading');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Error loading models';
  }
}

/**
 * Load years for a model
 */
async function loadYears(state, modelId, yearDropdown, searchBtn) {
  const trigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
  
  // Check cache first
  if (API_CACHE.years[modelId]) {
    console.log('🚗 Using cached years for model ID:', modelId);
    populateDropdownOptions(yearDropdown, API_CACHE.years[modelId], state, 'year');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
    return;
  }
  
  console.log('🚗 Fetching years for model ID:', modelId);
  
  // Set loading state
  trigger.setAttribute('data-loading', 'true');
  trigger.removeAttribute('data-disabled');
  trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Loading...';
  
  // Disable search button
  searchBtn.disabled = true;
  
  try {
    const _t0 = Date.now();
    const response = await fetch(`${LUNA_API_BASE}/years/?model_id=${modelId}`);
    const years = await response.json();
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', { category: 'make_model_year_finder', source: 'carousel_widget', action: 'api_latency', label: 'years|' + (Date.now() - _t0) + '|' + years.length });
    }
    
    console.log('🚗 Years loaded for model', state.model, ':', years.length);
    console.log('🚗 First year object:', years[0]);
    
    const yearItems = years.map(year => {
      // Handle if year is an object or a string/number
      const yearValue = typeof year === 'object' ? (year.year || year.value) : year;
      
      return {
        value: yearValue,
        label: String(yearValue)
      };
    });
    
    // Cache the results
    API_CACHE.years[modelId] = yearItems;
    
    populateDropdownOptions(yearDropdown, yearItems, state, 'year');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Select Year...';
    
  } catch (error) {
    console.error('🚗 Error loading years:', error);
    trigger.removeAttribute('data-loading');
    trigger.querySelector('.kits-finder__dropdown-text').textContent = 'Error loading years';
  }
}

/**
 * Update search button state
 */
function updateSearchButton(state, searchBtn) {
  // Allow search with just Make if no models available, otherwise require all fields
  const isReady = state.hasModels 
    ? (state.make && state.model && state.year)
    : state.make;
  
  const btnText = searchBtn.querySelector('.finder-btn-text');
  
  if (isReady) {
    searchBtn.disabled = false;
    searchBtn.style.opacity = '1';
    searchBtn.style.pointerEvents = 'auto';
    
    // Update button text to show what will be searched
    if (state.hasModels && state.model && state.year) {
      btnText.textContent = `Search ${state.make} ${state.model} ${state.year}`;
    } else if (state.make) {
      btnText.textContent = `Search ${state.make}`;
    }
    
    console.log('🚗 Search button enabled', state.hasModels ? '(all fields)' : '(make only)');
  } else {
    searchBtn.disabled = true;
    searchBtn.style.opacity = '0.5';
    searchBtn.style.pointerEvents = 'none';
    btnText.textContent = 'Search';
    
    console.log('🚗 Search button disabled - missing:', {
      make: state.make ? null : 'make',
      model: state.model ? null : 'model',
      year: state.year ? null : 'year',
      hasModels: state.hasModels
    });
  }
}

/**
 * Handle search button click
 */
async function onSearch(state, endpoint, drawerId) {
  console.log('🚗 onSearch called with state:', state);
  
  // Validate based on whether models are available
  if (!state.make) {
    console.error('🚗 Missing Make');
    return;
  }
  
  if (state.hasModels && (!state.model || !state.year || !state.modelId)) {
    console.error('🚗 Missing required fields (model/year)');
    return;
  }
  
  const searchBtn = state.container.querySelector('.finder-search-btn');
  const originalText = searchBtn.querySelector('.finder-btn-text').textContent;
  
  // Show loading state
  searchBtn.disabled = true;
  searchBtn.querySelector('.finder-btn-text').textContent = 'Searching...';
  
  console.log('🚗 Searching for colors:', {
    make: state.make,
    model: state.model || 'N/A',
    year: state.year || 'N/A',
    modelId: state.modelId || 'N/A',
    hasModels: state.hasModels
  });
  
  // Build search query for analytics
  const searchQuery = state.hasModels && state.model && state.year
    ? `${state.make} ${state.model} ${state.year}`
    : state.make;
  
  // Track analytics
  if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
    window.DYCAnalytics.track('custom', {
      category: 'make_model_year_finder', source: 'carousel_widget',
      action: 'search_executed',
      label: searchQuery,
      metadata: { hasModels: state.hasModels }
    });
  }
  
  // Save to recent searches
  saveRecentSearch(state);
  
  // If no models available, skip API call and open MCC directly with just Make
  if (!state.hasModels) {
    console.log('🚗 No models available - opening MCC with Make only');
    openMCCWithSearch(state);
    searchBtn.disabled = false;
    searchBtn.querySelector('.finder-btn-text').textContent = originalText;
    return;
  }
  
  console.log('🚗 Calling search endpoint:', endpoint);
  
  try {
    const customResponse = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model_id: state.modelId,
        year: state.year
      })
    });

    const response = await customResponse.json();
    console.log('🚗 Search response:', response);

    if (response.status === 'success') {
      console.log('🚗 Search successful:', response.colors?.length || 0, 'colors');

      // Open MCC iframe directly with search query
      if (response.colors && response.colors.length > 0) {
        openMCCWithSearch(state);
      } else {
        alert('No colors found for this vehicle');
      }
    } else {
      console.error('🚗 Search failed:', response);
      alert('Search failed: ' + (response.message || 'Unknown error'));
    }
  } catch (error) {
    console.error('🚗 Search error:', error);
    alert('Search error: ' + (error instanceof Error ? error.message : 'Unknown error'));
  } finally {
    searchBtn.disabled = false;
    searchBtn.querySelector('.finder-btn-text').textContent = originalText;
  }
}

/**
 * Open MCC app with search query
 */
function openMCCWithSearch(state) {
  console.log('🚗 Opening MCC app with search query');

  // Add class to body to hide Shopify chat via CSS
  document.body.classList.add('mcc-drawer-open');

  // Get or create the MCC iframe
  let iframe = document.getElementById('mcc-iframe');

  if (!iframe) {
    console.log('🚗 MCC iframe not found, creating one...');
    iframe = createMCCIframe();
  }

  // Build search query from state - use available fields
  let searchQuery;
  if (state.hasModels && state.model && state.year) {
    // Full query: Make Model Year
    searchQuery = `${state.make} ${state.model} ${state.year}`;
  } else {
    // Just Make (when no models available)
    searchQuery = state.make;
  }
  console.log('🚗 Search query:', searchQuery);
  
  // Show the iframe
  iframe.style.display = 'block';
  
  // Check if we're in product-view mode (for OEM landing page)
  const mode = state.container?.dataset.mode || 'shop';
  console.log('🚗 MCC Mode:', mode);
  
  // Send message to MCC app
  const message = {
    type: 'openModal',
    window: 'colorSearch',
    searchQuery: searchQuery,
    mode: mode  // Pass mode to MCC app
  };
  
  console.log('🚗 Sending message to MCC app:', message);
  
  // Wait for iframe to be ready, then send message
  setTimeout(() => {
    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage(message, '*');
      console.log('🚗 Message sent to MCC app');
    }
  }, 100);
}

/**
 * Recent searches management
 */
function saveRecentSearch(state) {
  const searches = getRecentSearches();
  const newSearch = {
    make: state.make,
    model: state.model || null,
    year: state.year || null,
    timestamp: Date.now()
  };
  
  // Remove duplicates, add to front
  const filtered = searches.filter(s => 
    !(s.make === newSearch.make && s.model === newSearch.model && s.year === newSearch.year)
  );
  filtered.unshift(newSearch);
  
  // Keep last 5
  localStorage.setItem('mmyf_recent', JSON.stringify(filtered.slice(0, 5)));
  renderRecentSearches(state);
}

function getRecentSearches() {
  try {
    return JSON.parse(localStorage.getItem('mmyf_recent') || '[]');
  } catch {
    return [];
  }
}

function renderRecentSearches(state) {
  const container = state.container.querySelector('.recent-searches-container');
  const toggleBtn = state.container.querySelector('.recent-searches-toggle-btn');
  const dropdown = state.container.querySelector('.recent-searches-dropdown');
  
  if (!container) return;
  
  const searches = getRecentSearches();
  
  if (searches.length === 0) {
    container.style.display = 'none';
    if (toggleBtn) toggleBtn.style.display = 'none';
    if (dropdown) dropdown.style.display = 'none';
    return;
  }
  
  // Check if mobile (width <= 749px)
  const isMobile = window.innerWidth <= 749;
  
  // On mobile: always use dropdown if any searches exist (keeps buttons aligned on one line)
  // On desktop: use dropdown if 2+ searches
  const shouldCollapse = isMobile ? searches.length >= 1 : searches.length >= 2;
  
  if (shouldCollapse) {
    // Show toggle button with dropdown, hide inline container
    // (Mobile: 1+ searches, Desktop: 2+ searches)
    container.style.display = 'none';
    if (toggleBtn) {
      toggleBtn.style.display = 'inline-flex';
      const toggleText = toggleBtn.querySelector('.recent-toggle-text');
      if (toggleText) {
        toggleText.textContent = `Recent (${searches.length})`;
      }
    }
    
    // Populate dropdown
    if (dropdown) {
      dropdown.style.display = 'block';
      dropdown.innerHTML = '<div class="recent-searches-dropdown-content">' +
        searches.map((s, index) => {
          const label = s.model && s.year ? `${s.make} ${s.model} ${s.year}` : s.make;
          return `<button class="recent-search-chip" data-index="${index}">${label}</button>`;
        }).join('') +
        '</div>';
      
      // Add click handlers for dropdown chips
      dropdown.querySelectorAll('.recent-search-chip').forEach((chip, index) => {
        chip.addEventListener('click', () => {
          const search = searches[index];
          applyRecentSearch(state, search);
          
          // Close dropdown
          dropdown.classList.remove('open');
          if (toggleBtn) toggleBtn.classList.remove('open');
          
          // Track analytics
          if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
            window.DYCAnalytics.track('custom', {
              category: 'make_model_year_finder', source: 'carousel_widget',
              action: 'recent_search_clicked',
              label: chip.textContent
            });
          }
        });
      });
    }
  } else {
    // Desktop with 0-1 searches: Show inline, hide toggle
    // (Mobile never reaches here with searches.length > 0)
    if (toggleBtn) toggleBtn.style.display = 'none';
    if (dropdown) {
      dropdown.style.display = 'none';
      dropdown.classList.remove('open');
    }
    
    container.style.display = 'flex';
    container.innerHTML = '<div class="recent-searches-label">Recent:</div>' +
      searches.map((s, index) => {
        const label = s.model && s.year ? `${s.make} ${s.model} ${s.year}` : s.make;
        return `<button class="recent-search-chip" data-index="${index}">${label}</button>`;
      }).join('');
    
      // Add click handlers for inline chips
    container.querySelectorAll('.recent-search-chip').forEach((chip, index) => {
      chip.addEventListener('click', () => {
        const search = searches[index];
        applyRecentSearch(state, search);
        
        // Track analytics
        if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
          window.DYCAnalytics.track('custom', {
            category: 'make_model_year_finder', source: 'carousel_widget',
            action: 'recent_search_clicked',
            label: chip.textContent
          });
        }
      });
    });
  }
  
  // Setup toggle button click handler (only once)
  if (toggleBtn && !toggleBtn.dataset.initialized) {
    toggleBtn.dataset.initialized = 'true';
    
    // Move dropdown to body on first initialization (like main dropdowns)
    if (dropdown && dropdown.parentElement !== document.body) {
      document.body.appendChild(dropdown);
      dropdown.setAttribute('data-finder-type', 'recent-searches');
      console.log('🚗 Moved recent searches dropdown to body');
    }
    
    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      
      const isOpen = toggleBtn.classList.contains('open');
      toggleBtn.classList.toggle('open');
      
      if (dropdown) {
        dropdown.classList.toggle('open');
        
        // Position the dropdown relative to the toggle button
        if (!isOpen) {
          requestAnimationFrame(() => {
            const rect = toggleBtn.getBoundingClientRect();
            dropdown.style.position = 'fixed';
            dropdown.style.top = `${rect.bottom + 8}px`;
            dropdown.style.left = `${rect.left}px`;
            dropdown.style.right = 'auto';
            console.log('🚗 Positioned recent searches dropdown:', { top: rect.bottom + 8, left: rect.left });
          });
        }
      }
      
      // Track analytics
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'make_model_year_finder', source: 'carousel_widget',
          action: 'recent_dropdown_toggled',
          label: dropdown?.classList.contains('open') ? 'opened' : 'closed'
        });
      }
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (toggleBtn && dropdown && !toggleBtn.contains(e.target) && !dropdown.contains(e.target)) {
        toggleBtn.classList.remove('open');
        dropdown.classList.remove('open');
      }
    });
    
    // Close dropdown immediately on scroll
    window.addEventListener('scroll', () => {
      if (dropdown && dropdown.classList.contains('open')) {
        toggleBtn.classList.remove('open');
        dropdown.classList.remove('open');
      }
    }, { passive: true });
    
    // Reposition on window resize
    window.addEventListener('resize', () => {
      if (dropdown && dropdown.classList.contains('open')) {
        requestAnimationFrame(() => {
          const rect = toggleBtn.getBoundingClientRect();
          dropdown.style.top = `${rect.bottom + 8}px`;
          dropdown.style.left = `${rect.left}px`;
        });
      }
    });
  }
  
  // Re-render on window resize to handle mobile/desktop switch
  const handleResize = () => renderRecentSearches(state);
  window.removeEventListener('resize', handleResize);
  window.addEventListener('resize', handleResize);
}

async function applyRecentSearch(state, search) {
  console.log('🚗 Applying recent search:', search);
  
  const makeDropdown = state.container.querySelector('.make-dropdown');
  const modelDropdown = state.container.querySelector('.model-dropdown');
  const yearDropdown = state.container.querySelector('.year-dropdown');
  const searchBtn = state.container.querySelector('.finder-search-btn');
  
  // Set make
  state.make = search.make;
  state.model = null;
  state.modelId = null;
  state.year = null;
  state.hasModels = true;
  
  // Update make dropdown text
  const makeTrigger = makeDropdown.querySelector('.kits-finder__dropdown-trigger');
  makeTrigger.querySelector('.kits-finder__dropdown-text').textContent = search.make;
  
  // Load models
  await loadModels(state, search.make, modelDropdown, yearDropdown, searchBtn);
  
  // If recent search has model/year, set them
  if (search.model && state.hasModels) {
    state.model = search.model;
    const modelTrigger = modelDropdown.querySelector('.kits-finder__dropdown-trigger');
    modelTrigger.querySelector('.kits-finder__dropdown-text').textContent = search.model;
    
    // Find modelId from cached models
    const cachedModels = API_CACHE.models[search.make];
    if (cachedModels) {
      const modelItem = cachedModels.find(m => m.value === search.model);
      if (modelItem) {
        state.modelId = modelItem.id;
        
        // Load years
        await loadYears(state, modelItem.id, yearDropdown, searchBtn);
        
        // Set year if available
        if (search.year) {
          state.year = search.year;
          const yearTrigger = yearDropdown.querySelector('.kits-finder__dropdown-trigger');
          yearTrigger.querySelector('.kits-finder__dropdown-text').textContent = search.year;
        }
      }
    }
  }
  
  // Update search button
  updateSearchButton(state, searchBtn);
  
  // Automatically execute the search
  console.log('🚗 Auto-executing search from recent selection');
  await onSearch(state, state.endpoint, state.drawerId);
}

// ── License Plate Search ──────────────────────────────────────────────────

/**
 * US States for license plate decoding
 */
const US_STATES = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }, { code: 'DC', name: 'District of Columbia' },
];

/**
 * Setup license plate search toggle and UI
 */
function setupPlateSearchToggle(state, container) {
  const plateToggleBtn = container.querySelector('.finder-plate-toggle');
  const plateContainer = container.querySelector('.finder-plate-search-container');
  const finderContainer = container.querySelector('.finder-container');
  const bottomRow = container.querySelector('.finder-bottom-row');
  const textSearchContainer = container.querySelector('.finder-text-search-container');
  
  // Find the subtext elements (both desktop and mobile)
  const slide = container.closest('.slider-slide');
  const subtextElements = slide ? slide.querySelectorAll('.finder-subtext') : [];
  
  if (!plateToggleBtn || !plateContainer) return;
  
  // Get decode endpoint
  const decodeEndpoint = plateContainer.dataset.decodeEndpoint;
  
  // Plate search state (US plates only)
  const plateState = {
    type: 'us_plate',
    value: '',
    stateCode: '',
    decodeEndpoint: decodeEndpoint,
  };
  
  // Get UI elements
  const plateInput = plateContainer.querySelector('.plate-input');
  const decodeBtn = plateContainer.querySelector('.plate-decode-btn');
  const resultContainer = plateContainer.querySelector('.plate-decode-result');
  const backBtn = plateContainer.querySelector('.plate-back-btn');
  const stateDropdown = plateContainer.querySelector('.plate-state-dropdown');
  
  // Initialize state dropdown with US states
  initPlateStateDropdown(stateDropdown, plateState, decodeBtn, plateInput);
  
  // Plate input handler
  plateInput.addEventListener('input', (e) => {
    plateState.value = e.target.value.toUpperCase();
    e.target.value = plateState.value; // Force uppercase
    updatePlateDecodeButton(plateState, decodeBtn);
  });
  
  plateInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!decodeBtn.disabled) {
        handlePlateDecodeClick(state, plateState, decodeBtn, resultContainer);
      }
    }
  });
  
  // Decode button click
  decodeBtn.addEventListener('click', () => {
    handlePlateDecodeClick(state, plateState, decodeBtn, resultContainer);
  });

  // ── Scan Plate (OCR Camera) Button ──────────────────────────────────
  const scanBtn = plateContainer.querySelector('.plate-scan-btn');
  if (scanBtn) {
    scanBtn.addEventListener('click', function () {
      // Must be called from direct user gesture for getUserMedia
      if (!window.LicensePlateScanner) {
        console.warn('🚗 LicensePlateScanner module not loaded');
        return;
      }

      window.LicensePlateScanner.open({
        onResult: function (data) {
          // data = { plate, state }
          console.log('🚗 Plate scanned:', data);

          // Fill in the plate input & state, then auto-decode
          plateState.value = data.plate;
          plateState.stateCode = data.state;
          plateInput.value = data.plate;

          // Update state dropdown trigger text
          const stateTriggerText = stateDropdown
            ? stateDropdown.querySelector('.kits-finder__dropdown-text')
            : null;
          if (stateTriggerText) {
            stateTriggerText.textContent = data.state;
          }

          updatePlateDecodeButton(plateState, decodeBtn);

          // Auto-trigger decode
          handlePlateDecodeClick(state, plateState, decodeBtn, resultContainer);
        },
        onCancel: function () {
          console.log('🚗 Plate scan cancelled');
        },
      });
    });
  }

  // Toggle to plate search mode
  plateToggleBtn.addEventListener('click', () => {
    // Capture scroll position before any layout changes
    var savedScrollY = window.scrollY;

    // Update subtext - use data attribute from settings or default
    const plateSubheading = plateContainer.getAttribute('data-plate-subheading') || 'Enter your license plate to instantly find your vehicle and matching colors.';
    subtextElements.forEach(el => {
      el.innerHTML = plateSubheading;
      el.style.display = '';
    });

    // Hide dropdown mode
    finderContainer.classList.add('hidden-mode');
    if (bottomRow) {
      bottomRow.style.opacity = '0';
      bottomRow.style.transition = 'opacity 0.2s ease';
    }
    // Also hide text search if it was open
    if (textSearchContainer) {
      textSearchContainer.classList.remove('active');
      textSearchContainer.style.display = 'none';
    }

    // Show plate search
    setTimeout(() => {
      if (bottomRow) {
        bottomRow.style.display = 'none';
      }
      plateContainer.style.display = 'flex';
      plateContainer.style.flexDirection = 'column';
      plateContainer.style.alignItems = 'center';
      plateContainer.style.gap = '0.75rem';
      requestAnimationFrame(() => {
        plateContainer.classList.add('active');
        // Restore scroll position after layout settles
        window.scrollTo(0, savedScrollY);
      });
    }, 150);
    
    // Track analytics
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'mode_switched',
        label: 'license_plate'
      });
    }
  });
  
  // Back button
  backBtn.addEventListener('click', () => {
    // Capture scroll position before any layout changes
    var savedScrollY = window.scrollY;

    // Restore subtext
    subtextElements.forEach(el => {
      const dropdownText = el.getAttribute('data-dropdown-text');
      if (dropdownText) {
        el.innerHTML = dropdownText;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    // Restore plate inputs if they were hidden during loading/result state
    const inputRow = plateContainer.querySelector('.plate-input-row');
    const decodeBtn = plateContainer.querySelector('.plate-decode-btn');
    const resultDiv = plateContainer.querySelector('.plate-decode-result');
    const scanBtnRestore = plateContainer.querySelector('.plate-scan-btn');
    if (inputRow) inputRow.style.display = 'flex';
    if (decodeBtn) decodeBtn.style.display = 'flex';
    if (scanBtnRestore) scanBtnRestore.style.display = '';
    if (resultDiv) {
      resultDiv.style.display = 'none';
      resultDiv.innerHTML = '';
    }

    plateContainer.classList.remove('active');

    setTimeout(() => {
      plateContainer.style.display = 'none';
      finderContainer.classList.remove('hidden-mode');
      if (bottomRow) {
        bottomRow.style.display = 'flex';
        bottomRow.style.opacity = '0';
        requestAnimationFrame(() => {
          bottomRow.style.transition = 'opacity 0.3s ease';
          bottomRow.style.opacity = '1';
          // Restore scroll position after layout settles
          window.scrollTo(0, savedScrollY);
        });
      } else {
        window.scrollTo(0, savedScrollY);
      }
    }, 150);
    
    // Track analytics
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'mode_switched',
        label: 'dropdown'
      });
    }
  });
}

/**
 * Initialize the state dropdown for US license plates
 */
function initPlateStateDropdown(dropdown, plateState, decodeBtn, plateInput) {
  if (!dropdown) return;
  
  const trigger = dropdown.querySelector('.kits-finder__dropdown-trigger');
  const optionsContainer = dropdown.querySelector('.kits-finder__dropdown-options');
  
  if (!trigger || !optionsContainer) return;
  
  let optionsMovedToBody = false;
  
  // Toggle dropdown
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const isOpen = dropdown.classList.contains('open');
    
    // Close all other dropdowns
    document.querySelectorAll('.kits-finder__dropdown.open').forEach(d => {
      if (d !== dropdown) {
        d.classList.remove('open');
      }
    });
    
    dropdown.classList.toggle('open', !isOpen);
    
    if (!isOpen) {
      if (!optionsMovedToBody) {
        document.body.appendChild(optionsContainer);
        optionsContainer.setAttribute('data-finder-type', 'plate-state');
        optionsContainer._parentDropdown = dropdown;
        optionsMovedToBody = true;
      }
      
      // Lock scroll
      if (!document.body.hasAttribute('scroll-locked')) {
        const scrollY = window.scrollY;
        document.body.dataset.scrollY = scrollY;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.setAttribute('scroll-locked', 'true');
      }
      
      requestAnimationFrame(() => {
        const rect = trigger.getBoundingClientRect();
        optionsContainer.style.position = 'fixed';
        optionsContainer.style.top = rect.bottom + 'px';
        optionsContainer.style.left = rect.left + 'px';
        optionsContainer.style.setProperty('width', rect.width + 'px', 'important');
      });
      
      optionsContainer.classList.add('open');
    } else {
      optionsContainer.classList.remove('open');
      unlockScrollIfNoDropdowns();
    }
  });
  
  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target) && !optionsContainer.contains(e.target)) {
      if (dropdown.classList.contains('open')) {
        dropdown.classList.remove('open');
        optionsContainer.classList.remove('open');
        unlockScrollIfNoDropdowns();
      }
    }
  });
  
  // Add search input
  const searchInput = document.createElement('input');
  searchInput.type = 'text';
  searchInput.className = 'kits-finder__dropdown-search';
  searchInput.placeholder = 'Search state...';
  searchInput.addEventListener('click', e => e.stopPropagation());
  searchInput.addEventListener('input', e => {
    filterDropdownOptions(e.target.value, optionsContainer);
  });
  optionsContainer.appendChild(searchInput);
  
  // Add state options
  US_STATES.forEach(st => {
    const option = document.createElement('div');
    option.className = 'kits-finder__dropdown-option';
    option.dataset.value = st.code;
    
    const text = document.createElement('span');
    text.className = 'dropdown-option-text';
    text.textContent = `${st.code} - ${st.name}`;
    option.appendChild(text);
    
    option.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      plateState.stateCode = st.code;
      trigger.querySelector('.kits-finder__dropdown-text').textContent = st.code;
      
      // Mark selected
      optionsContainer.querySelectorAll('.kits-finder__dropdown-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
      
      // Close dropdown
      dropdown.classList.remove('open');
      optionsContainer.classList.remove('open');
      unlockScrollIfNoDropdowns();
      
      updatePlateDecodeButton(plateState, decodeBtn);
      
      // Focus back on plate input if empty (preventScroll stops page jump)
      if (!plateState.value) {
        plateInput.focus({ preventScroll: true });
      }
    });
    
    optionsContainer.appendChild(option);
  });
  
  // Setup scroll behavior
  setupDropdownScrollBehavior(optionsContainer, searchInput);
}

/**
 * Helper: unlock body scroll if no dropdowns are open
 */
function unlockScrollIfNoDropdowns() {
  const hasOpenDropdowns = document.querySelectorAll('.kits-finder__dropdown.open').length > 0;
  if (!hasOpenDropdowns && document.body.hasAttribute('scroll-locked')) {
    const scrollY = document.body.dataset.scrollY;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.removeAttribute('scroll-locked');
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY));
      delete document.body.dataset.scrollY;
    }
  }
}

/**
 * Update the decode button enabled/disabled state
 */
function updatePlateDecodeButton(plateState, decodeBtn) {
  const btnText = decodeBtn.querySelector('.finder-btn-text');
  
  // US plates only - need plate + state
  const ready = plateState.value.length >= 2 && plateState.stateCode;
  decodeBtn.disabled = !ready;
  decodeBtn.style.opacity = ready ? '1' : '0.5';
  decodeBtn.style.pointerEvents = ready ? 'auto' : 'none';
  
  btnText.textContent = 'Find My Color';
}

/**
 * Handle decode button click - call API and process result
 * Includes retry logic for empty results
 */
async function handlePlateDecodeClick(finderState, plateState, decodeBtn, resultContainer) {
  // Get parent elements for morphing effect
  const plateContainer = decodeBtn.closest('.finder-plate-search-container');
  const inputRow = plateContainer.querySelector('.plate-input-row');
  
  // Hide inputs, buttons, and scan button during search
  inputRow.style.display = 'none';
  decodeBtn.style.display = 'none';
  var scanBtn = plateContainer.querySelector('.plate-scan-btn');
  if (scanBtn) scanBtn.style.display = 'none';
  
  // Show the morphing loader
  resultContainer.style.display = 'block';
  resultContainer.innerHTML = `
    <div class="plate-search-loading-container">
      <div class="plate-loader-square">
        <svg class="plate-loader-wheel" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="9" stroke-dasharray="4 2" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1" fill="currentColor" />
        </svg>
      </div>
      <div class="plate-loader-text">
        <div class="plate-loader-title">Finding Your Vehicle</div>
        <div class="plate-loader-subtitle">${plateState.value} • ${plateState.stateCode}</div>
      </div>
    </div>
  `;
  
  // Track analytics
  if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
    window.DYCAnalytics.track('custom', {
      category: 'make_model_year_finder', source: 'carousel_widget',
      action: 'plate_decode_started',
      label: `${plateState.type}: ${plateState.value}`,
      metadata: { state: plateState.stateCode || 'N/A' }
    });
  }
  
  // Helper to call the decode API
  async function callDecodeAPI() {
    const response = await fetch(plateState.decodeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: plateState.type,
        value: plateState.value,
        state: plateState.stateCode,
      }),
    });
    
    const responseText = await response.text();
    let responseData;
    try {
      responseData = responseText ? JSON.parse(responseText) : {};
    } catch (parseError) {
      console.error('🚗 Failed to parse response:', responseText);
      throw new Error('Invalid response from server');
    }
    
    if (!response.ok) {
      throw new Error(responseData.error || 'Failed to decode vehicle');
    }
    
    return responseData;
  }
  
  try {
    let vehicleData = null;
    let attempts = 0;
    const maxAttempts = 2;
    
    // Retry logic - try up to 2 times if we get empty results
    while (attempts < maxAttempts) {
      vehicleData = await callDecodeAPI();
      console.log(`🚗 Vehicle decode attempt ${attempts + 1}:`, vehicleData);
      
      // Check if we have meaningful data
      if (vehicleData.make && vehicleData.model) {
        break; // Success - we have vehicle data
      }
      
      // If first attempt returned no data, retry after a short delay
      if (attempts < maxAttempts - 1) {
        console.log('🚗 No vehicle data, retrying...');
        // Update loader text
        const loaderTitle = resultContainer.querySelector('.plate-loader-title');
        if (loaderTitle) loaderTitle.textContent = 'Still searching...';
        await new Promise(resolve => setTimeout(resolve, 800));
      }
      
      attempts++;
    }
    
    // Check if we got valid data
    if (!vehicleData || !vehicleData.make) {
      throw new Error('Vehicle not found. Please check your plate number and state.');
    }
    
    console.log('🚗 Vehicle decoded successfully:', vehicleData);
    
    // Update finder state with decoded data
    finderState.make = vehicleData.make || null;
    finderState.model = vehicleData.model || null;
    finderState.year = vehicleData.year ? String(vehicleData.year) : null;
    
    // Save to recent searches
    saveRecentSearch(finderState);
    
    // Show success result with "View Matching Colors" button
    renderPlateDecodeResult(resultContainer, vehicleData, finderState);
    
    // Track success
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'plate_decode_success',
        label: `${vehicleData.make || ''} ${vehicleData.model || ''} ${vehicleData.year || ''}`.trim(),
        metadata: {
          type: vehicleData.type,
          colorCount: vehicleData.colors?.length || 0,
          hasVin: !!vehicleData.vin,
          attempts: attempts + 1,
        }
      });
    }
    
  } catch (error) {
    console.error('🚗 Plate decode error:', error);
    
    // Show error in the same horizontal layout
    resultContainer.innerHTML = `
      <div class="plate-result-container">
        <div class="plate-result-icon-box" style="border-color: rgba(239, 68, 68, 0.4); background: rgba(239, 68, 68, 0.1);">
          <svg viewBox="0 0 24 24" fill="none" stroke="#f87171" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>
        <div class="plate-result-card plate-result-error">
          <div class="plate-result-text">
            <div class="plate-result-vehicle-name">Vehicle Not Found</div>
            <span style="color: rgba(255,255,255,0.7);">${error.message || 'Unable to find this vehicle. Please check your plate number and try again.'}</span>
          </div>
          <button class="plate-view-colors-btn plate-try-again-btn" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 4v6h6M23 20v-6h-6"></path>
              <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
            </svg>
            Try Again
          </button>
        </div>
      </div>
    `;
    
    // Add try again handler
    const tryAgainBtn = resultContainer.querySelector('.plate-try-again-btn');
    if (tryAgainBtn) {
      tryAgainBtn.addEventListener('click', () => {
        // Reset to input state
        resultContainer.style.display = 'none';
        resultContainer.innerHTML = '';
        inputRow.style.display = 'flex';
        decodeBtn.style.display = 'flex';
      });
    }
    
    // Track error
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'make_model_year_finder', source: 'carousel_widget',
        action: 'plate_decode_error',
        label: error.message || 'unknown',
      });
    }
  }
}

/**
 * Render decoded vehicle result card with "View Matching Colors" button
 * Uses horizontal layout with liquid glass styling
 * Shows brand logo if available
 */
function renderPlateDecodeResult(container, data, finderState) {
  const make = data.make || 'Unknown';
  const model = data.model || '';
  const year = data.year || '';
  const color = data.color || '';
  const colors = data.colors || [];
  
  // Build color chips HTML
  let colorChipsHtml = '';
  if (colors.length > 0) {
    const chips = colors.slice(0, 2).map(c => {
      const swatchStyle = c.hex ? `background:${c.hex};` : 'background:#ccc;';
      const colorName = c.name || c.generic_name || c.code || '';
      return `<span class="plate-color-chip">
        <span class="plate-color-swatch" style="${swatchStyle}"></span>
        <span>${colorName}</span>
      </span>`;
    }).join('');
    
    const moreCount = colors.length > 2 ? `<span class="plate-color-chip plate-color-more">+${colors.length - 2} more</span>` : '';
    colorChipsHtml = `<div class="plate-colors-row">${chips}${moreCount}</div>`;
  }
  
  // Check for brand logo
  const brandLogoUrl = getBrandLogoUrl(make);
  
  // Build icon box content - brand logo or checkmark
  const iconBoxContent = brandLogoUrl 
    ? `<img src="${brandLogoUrl}" alt="${make} logo" class="plate-result-brand-logo" />`
    : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>`;
  
  // Build the result card HTML with horizontal layout
  const vehicleName = `${year} ${make} ${model}`.trim();
  container.innerHTML = `
    <div class="plate-result-container">
      <div class="plate-result-icon-box ${brandLogoUrl ? 'has-brand-logo' : ''}">
        ${iconBoxContent}
      </div>
      <div class="plate-result-card">
        <div class="plate-result-text">
          <div class="plate-result-vehicle-name">${vehicleName}</div>
          ${color ? `<span class="plate-result-factory-color">Factory: ${color}</span>` : ''}
          <span class="plate-result-description">We found colors available for your ${make} ${model}.</span>
        </div>
        <button class="plate-view-colors-btn" type="button">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
          View ${make} Colors
        </button>
      </div>
    </div>
  `;
  container.style.display = 'block';
  
  // Add click handler for the "View Matching Colors" button
  const viewColorsBtn = container.querySelector('.plate-view-colors-btn');
  if (viewColorsBtn && finderState) {
    viewColorsBtn.addEventListener('click', () => {
      // Track button click
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'make_model_year_finder', source: 'carousel_widget',
          action: 'plate_view_colors_clicked',
          label: `${year} ${make} ${model}`.trim(),
        });
      }
      
      // Open MCC with the vehicle info
      openMCCWithSearch(finderState);
    });
  }
}

/**
 * Create MCC iframe (matching mcc.js implementation)
 */
function createMCCIframe() {
  const iframeSrc = 'https://mcc-dyc.vercel.app';
  const iframe = document.createElement('iframe');

  iframe.src = iframeSrc;
  iframe.allow = 'fullscreen';
  iframe.style.position = 'fixed';
  iframe.style.top = '0';
  iframe.style.left = '0';
  iframe.style.width = '100%';
  iframe.style.height = '100vh';
  iframe.style.border = 'none';
  iframe.style.zIndex = '9999';
  iframe.style.display = 'none';
  iframe.id = 'mcc-iframe';
  iframe.className = 'mcc-iframe';

  document.body.appendChild(iframe);
  
  console.log('🚗 MCC iframe created');
  
  return iframe;
}

/**
 * Global message listener for MCC app responses
 * Handles color selection and redirect to product pages
 */
(function setupMCCMessageListener() {
  // Prevent duplicate listeners
  if (window.__mccMessageListenerInstalled) {
    console.log('🚗 MCC message listener already installed');
    return;
  }
  
  window.__mccMessageListenerInstalled = true;
  
  window.addEventListener('message', function(event) {
    // Verify message is from MCC app
    if (!event.data || typeof event.data !== 'object') return;
    
    // Handle color selection from MCC app (product-view mode)
    if (event.data.type === 'colorSelected') {
      console.log('🚗 Color selected from MCC:', event.data);
      
      const {
        shopifyProductId,
        shopifyVariantId,
        shopifyProductHandle,
        colorName,
        colorCode,
        brand,
        model,
        year
      } = event.data;
      
      // Build product URL with tracking parameters
      let productUrl;
      
      if (shopifyProductHandle) {
        // Use product handle (preferred)
        productUrl = `/products/${shopifyProductHandle}`;
      } else if (shopifyProductId) {
        // Fallback to product ID
        productUrl = `/products/${shopifyProductId}`;
      } else {
        console.error('🚗 No product ID or handle provided');
        return;
      }
      
      // Add variant if provided
      if (shopifyVariantId) {
        productUrl += `?variant=${shopifyVariantId}`;
      }
      
      // Add UTM tracking parameters
      const utmParams = new URLSearchParams({
        utm_source: 'oemcolors',
        utm_medium: 'landing_page',
        utm_campaign: 'mcc_search',
        utm_content: colorCode || colorName || ''
      });
      
      productUrl += (productUrl.includes('?') ? '&' : '?') + utmParams.toString();
      
      console.log('🚗 Redirecting to product page:', productUrl);
      
      // Track analytics before redirect
      if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
        window.DYCAnalytics.track('custom', {
          category: 'oem_landing',
          action: 'color_selected',
          label: `${colorName || 'Unknown'} (${colorCode || 'N/A'})`,
          metadata: {
            brand: brand,
            model: model,
            year: year,
            shopifyProductId: shopifyProductId,
            shopifyVariantId: shopifyVariantId
          }
        });
      }
      
      // Redirect to product page
      window.location.href = productUrl;
    }
    
    // Handle MCC app close event
    if (event.data.type === 'closeModal') {
      console.log('🚗 Closing MCC iframe');
      const iframe = document.getElementById('mcc-iframe');
      if (iframe) {
        iframe.style.display = 'none';
      }
    }
  });
  
  console.log('🚗 MCC message listener installed successfully');
})();

// Expose API for nav-finder.js and other consumers
window.DYCFinderAPI = {
  openMCCText: openMCCWithTextQuery,
  openMCCSearch: openMCCWithSearch,
  createMCCIframe: createMCCIframe
};

// End of IIFE wrapper
})();
